import Timeline from '@components/timeline/Timeline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import IconClock from '@ui/icons/imaterial/time-and-date/Clock.svg';
import makeStyles from '@ui/utils/makeStyles';
import shortAddress from '@ui/utils/shortAddress';
import React, { useState } from 'react';


const useStyles = makeStyles()({
  dialogPaper: {
    background: '#f7f7f7',
  },
});

const TimelineQuickView: React.FC<{ home: guesthouse.Home }> = (props) => {
  const { home } = props;
  const [open, setOpen] = useState(false);
  const { classes } = useStyles();
  const address = shortAddress(home?.address);

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <>
      <IconButton
        style={{
          padding: 5,
        }}
        aria-label="view timeline"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setOpen(true);
        }}
      >
        <IconClock
          style={{ 
            width: 15, 
            height: 15 
          }}
        />
      </IconButton>
      <Dialog
        fullWidth
        aria-labelledby="timeline-quick-view"
        open={open}
        maxWidth="md"
        classes={{
          paper: classes.dialogPaper
        }}
        onClose={handleClose}
      >
        <DialogTitle id="timeline-quick-view">
          Timeline
          {' '}
          -
          {' '}
          {address}
        </DialogTitle>
        <DialogContent>
          <Timeline home={home} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TimelineQuickView;
